export default __webpack_public_path__ + "static/media/giff.938b3d89.gif";